import { action } from 'mobx';
import {BaasicDropdownStore, BaseEditViewStore} from 'core/stores';
import {ImportItemGroupEditForm} from 'application/import/forms';
import { ImportDetailService } from 'application/import/services';
import {ImportReferenceService} from 'application/import-reference/services';
import _ from 'lodash';

class ImportItemGroupEditViewStore extends BaseEditViewStore {
    constructor(rootStore, componentParams) {
        const importDetailService = new ImportDetailService(rootStore.application.baasic.apiClient);
        const importReferenceService = new ImportReferenceService(rootStore.application.baasic.apiClient);
        const id = rootStore.routerStore.routerState.params.id;
        const patientKey = parseInt(componentParams.modalParams.data.patientKey);
        const itemGroupId = componentParams.modalParams.data.itemGroupId;
        super(rootStore, {
            name: 'item group',
            id: id,
            actions: () => {
                return {
                    get: async () => {
                        const response = await importDetailService.findItemGroup({patientKey: patientKey, itemGroupId: itemGroupId });
                        return response;
                    },
                    update: async (resource) => {
                        const response = await importDetailService.update(_.extend(resource, {patientKey: patientKey, itemGroupId: itemGroupId }));
                        return response;
                    }
                }
            },
            FormClass: ImportItemGroupEditForm
        });

        this.modalParams = componentParams.modalParams;

        this.referenceStore = new BaasicDropdownStore({
            filterable: true,
            dataItemKey: "name"
        }, {
            fetchFunc: async(term) => {
                const response = await importReferenceService.find({ searchQuery: term, rpp: 100, isActive: true, sort:"name|asc" });
                return response.data.item;          
             },
             onChange: (value)=>{
                this.form.set({ reference: value });
            }
        });
    }

    @action.bound
    async updateResource(resource) {
        this.loaderStore.suspend();
        this.form.setFieldsDisabled(true);
        try {
            await this.actions.update({
                ...resource,
            });
            this.modalParams.close();
            this.rootStore.notificationStore.success("Changes successfully saved.");
        }
        catch(err) {
            this.rootStore.notificationStore.error("Error occured while saving.");
        }
        this.form.setFieldsDisabled(false);
        this.loaderStore.resume();

    }
}

export default ImportItemGroupEditViewStore;
